import { skipToken } from '@reduxjs/toolkit/query';
import { legalEntitiesApi } from 'entities/legal-entities/legal-entities.api';
import { companyApi } from 'entities/company/details/api';
import { formatLegalEntity } from 'utils/legal-entity-format-helpers';

export const useLegalEntityLabel = (id?: string | null) => {
  const numericId = id ? Number(id) : undefined;
  const { data } = legalEntitiesApi.useGetLegalEntityQuery(numericId ?? skipToken, {
    skip: !numericId,
  });
  return data ? formatLegalEntity(data) : undefined;
};

export const useCompanyLabel = (id?: string | null) => {
  const numericId = id ? Number(id) : undefined;
  const { data } = companyApi.useGetCompanyDetailsQuery(numericId ?? skipToken, {
    skip: !numericId,
  });
  return data?.name;
};
